import React from "react";
import { connect } from "react-redux";
// import { Link } from "react-router-dom";
import Logo from "../../assets/images/logo/payeasy1.png";
import { Button, Result } from "antd";
import { logout } from "../../config/authsave";

class Lockscreen extends React.Component {
  render() {
    const Logout = () => {
      // this.props.history.push("login");
      logout();
    };
    return (
      <div className="theme-cyan">
        <div>
          <div className="vertical-align-wrap">
            <div className="vertical-align-middle auth-main">
              <div className="auth-box">
                <div className="card">
                  <div className="header d-none">
                    <h3>
                      <span className="clearfix title">
                        <span className="number left">
                          Error 403
                          <br />
                        </span>
                        <span className="text">Forbiddon Error!</span>
                      </span>
                    </h3>
                  </div>
                  <div className="body">
                    <div className="top text-center">
                      <img src={Logo} alt="Lucid" width={150} />
                    </div>
                    <div className="margin-top-30">
                      <Result
                        status="403"
                        title="403"
                        subTitle="!ขออภัย บัญชีขงคุณถูกระงับการใช้งาน"
                        extra={
                          <Button type="primary" onClick={() => Logout()}>
                            Back Home
                          </Button>
                        }
                      />
                      &nbsp;
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Lockscreen.propTypes = {};

const mapStateToProps = ({ loginReducer }) => ({});

export default connect(mapStateToProps, {})(Lockscreen);
